import { render, staticRenderFns } from "./UserNameDisplay.vue?vue&type=template&id=1cddb50a&scoped=true"
import script from "./UserNameDisplay.vue?vue&type=script&lang=js"
export * from "./UserNameDisplay.vue?vue&type=script&lang=js"
import style0 from "./UserNameDisplay.vue?vue&type=style&index=0&id=1cddb50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddb50a",
  null
  
)

export default component.exports